import { useState } from "react";
import Modal from "../../../../../global/Modal/Modal";
import EditAddressStep from "./EditAddressStep";

interface EditAddressFormProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const EditAddressForm = ({ open, setOpen }: EditAddressFormProps) => {
  const [AddressStep, setAddressStep] = useState(2);

  const handleCloseModal = () => {
    setAddressStep(2);
    setOpen(false);
  };

  return (
    <Modal
      visible={open}
      setVisible={() => {}}
      title="آدرس برگشت"
      handleClose={handleCloseModal}
    >
      <EditAddressStep
        AddressStep={AddressStep}
        setAddressStep={setAddressStep}
        outerOpen={open}
        setOuterOpen={setOpen}
      />
    </Modal>
  );
};

export default EditAddressForm;
